<template>
  <div id="shared-form-confirm-modal" class="modal fade" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-sm">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true"></button>
          <h4 class="modal-title">CONFIRM FORM SUBMISSION</h4>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">
              <p>This form can only be completed once. Please review your entry before submission.</p>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn green" @click.prevent="confirmSubmission">Confirm</button>
          <button class="btn default" data-dismiss="modal">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Spinner from "@/components/Spinner";

  export default {
    name: 'SharedFormConfirmModal',
    components: {
      VueSpinner: Spinner
    },
    data() {
      return {
        loading: false,
        title: ''
      }
    },
    mounted() {
      $('#shared-form-confirm-modal').modal('show');
      $('#shared-form-confirm-modal').on('hidden.bs.modal', () => {
        this.$emit('display', false);
      });
    },
    methods: {
      confirmSubmission() {
        this.$emit('confirm', true);
        this.$emit('display', false);
      }
    }
  }
</script>



// WEBPACK FOOTER //
// SharedFormConfirmModal.vue?4d273bda